<template>
    <content-layout>
        <template slot="header">
            <div class="breadcrumb">
                <span class="crumb"><router-link :to="{ name: 'home' }">Sākums</router-link></span>
                <span class="crumb">Jaunumi</span>
            </div>
            <h1 class="category-title">Jaunumi</h1>
        </template>

        <div class="row small-up-1 medium-up-2 large-up-3 posts-list">
            <spinner v-if="loading" class="spinner"></spinner>
            <div class="column post-item-wrapper" v-for="post in posts" :key="post.id">
                <post-item :post="post" class="post-item"/>
            </div>
        </div>

        <div class="pagination-container row align-center">
            <pagination :current.sync="page" :total="totalPages"></pagination>
        </div>
    </content-layout>
</template>

<script>
    import ContentLayout from '../layouts/CategoryLayout';
    import Pagination from '../components/common/Pagination';
    import PostItem from '../components/posts/PostItem'
    import posts from '../api/posts';

    export default {
        components: {ContentLayout, Pagination, PostItem},

        data() {
            return {
                posts: [],
                totalPages: 1,
                page: 1,
                loading: false
            }
        },

        watch: {
            page: function (val, oldVal) {
                this.loadPosts()
            }
        },

        methods: {
            loadPosts() {
                this.loading = true;
                posts.get({ page: this.page }).then(({ data }) => {
                    this.posts = data.data;
                    console.log("loaded posts", data);
                    this.totalPages = data.last_page ? data.last_page : 1;
                    this.page = data.current_page ? data.current_page : 1;
                    this.loading = false;
                })
            }
        },

        created() {
            this.loadPosts();
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/settings";
    @import "../../sass/mixins";

    .breadcrumb {
        color: white;
        font-size: px-em(12px);
    }

    .spinner {
        position: absolute;
        z-index: 2;
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: center;
        margin: 0;
    }

    .posts-list {
        position: relative;

        .post-item-wrapper {
            display: flex;
            align-items: stretch;
            justify-content: stretch;
            margin-bottom: 30px;
        }

        .post-item {
            width: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/Posts.vue